import { Http } from '@angular/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { Observable } from 'rxjs/Observable';
import { Warehouse } from './warehouse';
import { AuthenticationService } from '../_shared/services/authentication.service';
import { environment } from '../../environments/environment';
/**
 * Created by caterina on 04-05-17.
 */
@Injectable()
export class WarehouseService {
  private url = `${environment.apiUrl}/warehouse/`;

  constructor(private http: Http,
    private authService: AuthenticationService) {
  }

  /*TODO handle errors correctly*/
  getRootWarehouses() {
    return this.http.get(this.url, this.authService.getAuthOptions()).map(res => res.json());
  }

  get(id: number) {
    const url = `${this.url}${id}/`;
    return this.http.get(url, this.authService.getAuthOptions()).map(res => res.json());
  }

  update(warehouse: Warehouse) {
    const url = `${this.url}${warehouse.id}/`;
    return this.http.put(url, JSON.stringify(warehouse), this.authService.getAuthOptions())
      .map((res) => res.json());
  }

  calc(id: number) {
    const url = `${this.url}${id}/calc/`;
    return this.http.get(url, this.authService.getAuthOptions()).map(res => res.json());
  }

  minorElements(id: number) {
    const url = `${this.url}${id}/minor_elements/`;
    return this.http.get(url, this.authService.getAuthOptions()).map(res => res.json());
  }

  distributed_load(id: number) {
    const url = `${this.url}${id}/distributed_load/`;
    return this.http.get(url, this.authService.getAuthOptions()).map(res => res.json());
  }

  handleError(err: Response) {
    console.log(err.status);
    return Observable.throw(err);
  }

}



// WEBPACK FOOTER //
// ./src/app/project/warehouse.service.ts